import axios from '../lib/axios';

/**
 * Obtener listado de conversaciones con respuestas IA pendientes de moderación.
 */
export const getPendingConversations = () =>
    axios.get('/api/tutor/pending').then(r => r.data);

/**
 * Cuántos borradores de la IA esperan aprobación. Sólo el número: lo usa el
 * globo del menú, que no necesita traerse las conversaciones enteras.
 */
export const getPendingCount = () =>
    axios.get('/api/tutor/pending-count').then(r => r.data?.count ?? 0);

/**
 * Aprobar y enviar un mensaje de IA pendiente. Puede incluir un texto editado.
 * @param {number|string} messageId 
 * @param {string} body 
 */
export const approveMessage = (messageId, body) => 
    axios.post(`/api/tutor/messages/${messageId}/approve`, { body }).then(r => r.data);

/**
 * Cancelar/Rechazar una respuesta de IA pendiente.
 * @param {number|string} messageId 
 */
export const cancelMessage = (messageId) => 
    axios.post(`/api/tutor/messages/${messageId}/cancel`).then(r => r.data);

/**
 * Generar una respuesta sugerida por IA a demanda para una conversación.
 * @param {number|string} conversationId 
 */
export const generateAiResponse = (conversationId) =>
    axios.post(`/api/tutor/conversations/${conversationId}/generate-response`).then(r => r.data);

/**
 * Enviar una respuesta sugerida por IA (editada o directa) a demanda.
 * @param {number|string} conversationId 
 * @param {string} body 
 */
export const sendAiResponse = (conversationId, body) =>
    axios.post(`/api/tutor/conversations/${conversationId}/send-ai-response`, { body }).then(r => r.data);

/**
 * Obtener modelos de OpenRouter disponibles para optimización de prompt.
 */
export const getOpenRouterModels = () =>
    axios.get('/api/tutor/openrouter-models').then(r => r.data);

/**
 * Optimizar e integrar una sugerencia de prompt con OpenRouter.
 * @param {number|string} conversationId 
 * @param {object} payload - { instruction, model, apply_to_strategy }
 */
export const improvePromptWithAi = (conversationId, payload) =>
    axios.post(`/api/tutor/conversations/${conversationId}/improve-prompt`, payload).then(r => r.data);

/**
 * Guardar instrucciones aprendidas consolidadas en la estrategia activa.
 * @param {number|string} conversationId 
 * @param {string} learnedInstructions 
 */
export const saveLearnedInstructions = (conversationId, learnedInstructions) =>
    axios.post(`/api/tutor/conversations/${conversationId}/save-learned-instructions`, { learned_instructions: learnedInstructions }).then(r => r.data);

/**
 * Aplicar sugerencia de cambio al Master Prompt de la estrategia.
 * @param {number|string} conversationId 
 * @param {string} updatedMasterPrompt 
 */
export const applyMasterPromptSuggestion = (conversationId, updatedMasterPrompt) =>
    axios.post(`/api/tutor/conversations/${conversationId}/apply-master-prompt-suggestion`, { updated_master_prompt: updatedMasterPrompt }).then(r => r.data);



